import { make } from "vuex-pathify";
import apiLiveStream from "../../api/modules/liveStream";

const state = () => ({
  messages: [],
  mappingData: [],
  statusSubmit: null,
});

const getters = make.getters(state);

const actions = {
  async submitRequestLive({ commit }, dataRequest) {
    try {
      commit("SET_STATUS_SUBMIT", 0);
      let res = await apiLiveStream.requestLiveStream(dataRequest);
      if (res.data && res.data.code === 0) {
        commit("SET_STATUS_SUBMIT", 1);
      } else {
        commit("SET_STATUS_SUBMIT", -1);
      }
    } catch (err) {
      commit("SET_STATUS_SUBMIT", -1);
    }
  },
};

const mutations = {
  ...make.mutations(state),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
